module.exports = __webpack_public_path__ + "media/ejw/EJW_Logo_White-9eea1eb6.png";